import { Button, Typography, styled } from '@mui/material';

export const ButtonAction = styled(Button)(() => ({
  background: '#A03A7E !important',
  borderRadius: '44px',
  color: '#A03A7E',
  marginBlock: '0.5rem',
  '&:hover': {
    background: '#A03A7E',
  },
}));
export const TitleButton = styled(Typography)(({ theme }) => ({
  color: '#FFF7FC',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
}));
